import http from '../http'

export async function fetchOverview() {
    return await http.post('/overview')
}

export async function fetchLeads() {
    return await http.post('/leads/list')
}

export async function createLead(payload) {
    return await http.post('/leads', payload)
}

export async function assignLead(payload) {
    // 旧版工作台分配入口也必须提交勘探/研判飞手，保持与后端必填契约一致。
    return await http.post('/leads/assign', payload)
}

export async function fetchProjects() {
    return await http.post('/projects/list')
}

export async function fetchPartnerApplications() {
    return await http.post('/partner-applications/list')
}

export async function fetchFlightTasks() {
    return await http.post('/flight-tasks/list')
}

export async function fetchPayments() {
    return await http.post('/payments/list')
}

export async function confirmPayment(payload) {
    return await http.post('/payments/confirm', payload)
}
